import Status from "../../../components/Status";
import { STATUSES } from "../../../enums/AppointmentStatus";

export default function AppointmentStatusSymbol({ currentAppointment, testId }) {
  function getStatusOrder(status) {
    switch (status) {
      case STATUSES.WAITING_CLINIC:
        return 1;
      case STATUSES.ACTIVE:
        return 2;
      case STATUSES.FINISHED:
        return 4;
      case STATUSES.INACTIVE:
        return 5;
      case STATUSES.RESOLVED: 
        return 6;
      case STATUSES.WAITING_USER:
        return 7;
      default:
        return 8;
    }
  }

  function getStatusSymbol(status) {
    const order = getStatusOrder(status);
    const dotPadding = ".25em";
    return <Status status={order} dotPadding={dotPadding} testId={testId} />;
  }

  return getStatusSymbol(currentAppointment?.status);
}
